/* eslint no-param-reassign: ["error"] */
/* eslint no-return-assign: ["error"] */

import * as FormUtils from '../../util/formUtils';

const toggleArchiveText = () => {
  const { value } = document.getElementById('note_status');
  const div = document.querySelector('.archive-follow-up-text');

  if (value.startsWith('No Longer Client') || value.startsWith('Archive')) {
    div.classList.remove('hidden');
  } else {
    div.classList.add('hidden');
  }
};

const toggleButton = () => {
  const { value: status } = document.getElementById('note_status');
  const { value: message } = document.getElementById('note_message');
  const submitButtons = document.querySelectorAll('.match-update-submit');

  const messageOptionalStatuses = [
    'Client - In Escrow/Contract',
    'Client - Closed Escrow',
    'Contact Attempted',
    'Archive - No Response',
    'Archive - Has Other Agent',
  ];

  submitButtons.forEach((button) => {
    const submitButtonContainer = button.parentElement;

    if (status.length && (message.length || messageOptionalStatuses.includes(status))) {
      button.disabled = false;
      button.classList.remove('disabled');
      submitButtonContainer.classList.remove('gray');
    } else {
      button.disabled = true;
      button.classList.add('disabled');
      submitButtonContainer.classList.add('gray');
    }
  });
};

const toggleTooltip = (event) => {
  const toggler = event.target;
  const tooltip = toggler.closest('.field').querySelector('.tooltip-container');

  if (tooltip.classList.contains('open')) {
    tooltip.classList.remove('open');
    toggler.classList.remove('active');
  } else {
    tooltip.classList.add('open');
    toggler.classList.add('active');
  }
};

const hideFormFields = () => {
  const divs = document.querySelectorAll('.buyer-appointment, .client-show-listed-property, .client-in-escrow-contract, .client-closed-escrow, .closing-documents');
  const tooltips = document.querySelectorAll('.tooltip-toggler');

  [...divs].forEach((div) => {
    if (!div.classList.contains('hidden')) div.classList.add('hidden');
  });

  [...tooltips].forEach((tooltip) => {
    if (tooltip.classList.contains('active')) tooltip.click();
  });
};

const toggleFormFields = () => {
  const { value } = document.getElementById('note_status');
  const buyerAppointment = document.querySelector('.buyer-appointment');
  const clientShowListedProperty = document.querySelector('.client-show-listed-property');
  const clientInEscrowContract = document.querySelector('.client-in-escrow-contract');
  const clientClosedEscrow = document.querySelectorAll('.client-closed-escrow');
  const closingDocuments = document.querySelector('.closing-documents');
  const canadian = document.getElementById('canadian-agent').getAttribute('data-canadian');

  hideFormFields();

  switch (value) {
    case 'Buyer Appointment':
      if (buyerAppointment) buyerAppointment.classList.remove('hidden');
      break;
    case 'Client - Show/Listed Property':
      if (clientShowListedProperty) clientShowListedProperty.classList.remove('hidden');
      break;
    case 'Client - In Escrow/Contract':
    case 'Client - Closed Escrow':
      // eslint-disable-next-line eqeqeq
      if (clientInEscrowContract && canadian === 'false') clientInEscrowContract.classList.remove('hidden');
      if (clientClosedEscrow) { clientClosedEscrow.forEach((e) => e.classList.remove('hidden')); }
      if (closingDocuments) closingDocuments.classList.remove('hidden');
      break;
    default:
      hideFormFields();
  }
};

const toggleEmailCheckbox = (event) => {
  const email = event.target.closest('.field').querySelector('input[type="checkbox"]');

  email.checked = !email.checked;

  if (email.checked) {
    event.target.classList.add('active');
  } else {
    event.target.classList.remove('active');
  }
};

const fileUploader = (event) => {
  const uploader = event.target.closest('.field').querySelector('input[type="file"]');

  uploader.click();
};

const togglefileUploadButton = (event) => {
  const field = event.target.closest('.field');

  if (field) {
    const uploader = field.querySelector('input[type="file"]');
    const button = field.querySelector('.rex-button');

    if (uploader && uploader.files.length) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  }
};

const resetForm = (event) => {
  const statusInput = event.target;
  const statusValue = statusInput.value;
  const form = statusInput.closest('form');
  const reminderInputs = form.querySelectorAll('[name^="note[reminder_attributes]"]');
  const reminderValues = [...reminderInputs].map((i) => i.value);
  const message = form.querySelector('[name="note[message]"]');
  const messageValue = message.value;
  const activeButtons = document.querySelectorAll('.rex-button.active');
  const commissionNodes = document.querySelectorAll('.agent-commission');

  form.reset();

  commissionNodes.forEach((node) => (node.value = node.dataset.originalValue || null));
  activeButtons.forEach((btn) => btn.classList.remove('active'));

  // Prevents reset of status, reminder, and message
  statusInput.value = statusValue;
  message.value = messageValue;
  [...reminderInputs].forEach((n, x) => (n.value = reminderValues[x]));
};

const updatePropertyAddress = () => {
  const addressInput = document.querySelector('[name="note[noteable][purchase_property_address]"]');
  const inputs = document.querySelectorAll('[name^="note[address]["]');
  const values = [...inputs].map((input) => input.value).filter((el) => (el === null || el.length));
  const country = values.shift();

  values.push(country);

  addressInput.value = values.join(' ');
};

const toggleStateOptions = (event) => {
  const country = event.target.value;
  const select = document.querySelector('[name="note[address][state]"]');
  const currOptions = select.querySelectorAll('option');
  const data = document.querySelector('.states_provinces').dataset;
  const options = (/US/).test(country) ? data.states : data.provinces;
  const blankOption = document.createElement('option');
  const selectOptions = JSON.parse(options).map((option) => {
    const opt = document.createElement('option');
    opt.value = option;
    opt.innerHTML = option;

    return opt;
  });

  currOptions.forEach((option) => {
    option.remove();
  });

  blankOption.innerHTML = (/US/).test(country) ? 'State' : 'Province';
  blankOption.value = '';

  select.append(blankOption);

  selectOptions.forEach((option) => {
    select.append(option);
  });

  select.value = '';
  select.dispatchEvent(new CustomEvent('change'));
};

const toggleReminderForm = (event, action) => {
  const element = event.target.closest('.note-container').querySelector('.reminder-form-container');

  if (action === 'open') {
    element.classList.remove('close');
    element.classList.add('open');
  } else {
    element.classList.add('close');
    element.classList.remove('open');
  }
};

const toggleReminderIcon = (element) => {
  if (element.classList.contains('fa-bell')) {
    element.classList.remove('fa-bell');
    element.classList.add('fa-circle-notch', 'fa-spin');
  } else {
    element.classList.add('fa-bell');
    element.classList.remove('fa-circle-notch', 'fa-spin');
  }
};

const submitReminderForm = (event) => {
  const form = event.target.closest('form');
  const noteContainer = form.closest('.note-container');
  const upsertReminderButton = form.querySelector('.upsert-reminder');
  const span = noteContainer.querySelector('.note-add-edit-reminder');
  const icon = noteContainer.querySelector('.reminder-icon');
  const method = (/(\/\d+)$/).test(form.action) ? 'PUT' : 'POST';

  toggleReminderIcon(icon);
  form.querySelector('.cancel-upsert-reminder').click();

  fetch(
    form.action,
    {
      method,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(FormUtils.serializeForm(form)),
    },
  ).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error('Failed. Try Again');
  }).then((parsedJson) => {
    toggleReminderIcon(icon);
    upsertReminderButton.value = 'Update';
    span.innerText = parsedJson.reminder_time;

    if (parsedJson.reminder_expired) {
      span.classList.add('note-reminder-expired');
    } else {
      span.classList.remove('note-reminder-expired');
    }
  }).catch((error) => {
    toggleReminderIcon(icon);
    span.innerText = error.message;
    span.classList.remove('note-reminder-expired');
  });
};

const copyAgentCommission = (event) => {
  const submitInput = document.querySelector('.original-commission');
  const copyInput = event.target;
  const parsedValue = parseFloat(copyInput.value);

  // Prevents from assigning NaN value
  if (parsedValue) {
    if (parsedValue < 2) {
      submitInput.value = 2;
    } else {
      submitInput.value = parsedValue;
    }
  } else {
    submitInput.value = null;
  }
};

const matchUpdateSubmit = (event) => {
  event.preventDefault();

  const button = event.target;
  const form = event.target.closest('form');

  button.disabled = true;
  button.classList.add('disabled');
  button.parentElement.classList.add('gray');

  form.submit();
};

export {
  matchUpdateSubmit,
  copyAgentCommission,
  fileUploader,
  resetForm,
  submitReminderForm,
  toggleArchiveText,
  toggleButton,
  toggleEmailCheckbox,
  togglefileUploadButton,
  toggleFormFields,
  toggleReminderForm,
  toggleStateOptions,
  toggleTooltip,
  updatePropertyAddress,
};
